// import SmileRed from "../../images/SmileRed.svg";
import { motion, useAnimation } from "framer-motion/dist/framer-motion";
import { useEffect } from "react";

const Smile = () => {
  const pathAnimation = useAnimation();

  useEffect(() => {
    async function sequence() {
      await pathAnimation.start({
        pathLength: 0,
        fill: "#ffffff00",
      });
      await pathAnimation.start({ pathLength: 1, transition: { duration: 1 } });
      pathAnimation.start({
        fill: "#ed1b33",
        transition: {
          ease: "easeInOut",
          duration: 0.8,
        },
      });
    }
    sequence();
  }, [pathAnimation]);
  return (
    <div>
      <svg
        className="SignSVG"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 180.79"
      >
        <motion.path
          id="smile"
          animate={pathAnimation}
          d="M495.51,155.83a332.07,332.07,0,0,1-245.7,108.24A332,332,0,0,1,4.46,156.21a17.41,17.41,0,0,1,.66-24L47.8,89.57a17.37,17.37,0,0,1,25.29.77,234.3,234.3,0,0,0,176,79.27A234.31,234.31,0,0,0,426,89.23a17.33,17.33,0,0,1,25.36-.84l43.51,43.51a17.32,17.32,0,0,1,.63,23.93"
          transform="translate(0 -83.28)"
        />
      </svg>
    </div>
  );
};

export default Smile;
